import axios from "axios";
import { Base_URL } from "../url";

export const saveExchangeRate = async (exchangeRateData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ExchangeRate/CreateExchangeRate?UserName=${userName}`,
      exchangeRateData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving exchange rate!";
  }
};

export const getExchangeRateTypes = () => {
  return [
    { value: "M", label: "M - Average Rate" },
    { value: "B", label: "B - Bank Rate" },
    { value: "G", label: "G - Buying Rate" },
  ];
};